// Constants
import { BeApiServiceEnum } from "constants/searchPage/BeApiEnum";

export const getUrlService = (typeService: BeApiServiceEnum): string => {
	switch (typeService) {
		case BeApiServiceEnum.TAGS_SERVICE:
			return process.env.NEXT_PUBLIC_API_URL_LEGACY_TAGS_SERVICE || "";
		case BeApiServiceEnum.SEO_INFO_SERVICE:
			return process.env.NEXT_PUBLIC_API_URL_SEO_INFO_SERVICE || "";
		case BeApiServiceEnum.USER_INFO_SERVICE:
			return process.env.NEXT_PUBLIC_API_URL_USER_INFO_SERVICE || "";
		case BeApiServiceEnum.URL_REDIRECT_SERVICE:
			return process.env.NEXT_PUBLIC_API_URL_REDIRECT_SERVICE || "";
		default:
			return "";
	}
};
